// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./terms.styl');

// the css is injected automatically
// require('css!modules/terms/terms.css');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// get the html for this module
var html = strip(require('raw!./terms.html'));
var parsing = require('parsing').terms;
var defaultRequired = false;

function parse(text, next) {

    strip(require('raw!./terms.html'), function(outputHtml) {

        var match = parsing.parse(text)
        if (match) {
            var container = document.createElement("div");
            container.innerHTML = outputHtml;

            var labelDom = container.querySelector('label');
            labelDom.innerHTML = match[1].replace(/[\r\n]/g, '<br/>');
            var domObj = container.firstChild;
            var input = domObj.getElementsByTagName("input")[0];
            input.setAttribute("data-required", "true");

            outputHtml = container.innerHTML;

            text = text.replace(match[0], outputHtml);

        }

        next(text);

    });

};

function get(context) {
    var input = context.getElementsByTagName("input");
    var checked = input.checkbox.checked;
    if (checked) {
        var agreement = "agree";
    }
    return agreement;
}

function init(formRoot, meta, next) {
    var context = formRoot.querySelector('[data-module="terms"]');
    if (context){
        context.addEventListener('change', validate.bind(this, context), true);
    }
    next(formRoot);
}


function validate(context) {
    var ok = true;
    var inputs = context.getElementsByTagName("input");
    var checked = inputs.checkbox.checked;
    var messagelabel = context.querySelector("#txt_terms-error");
    var currentClasses = messagelabel.getAttribute("class") || "";
     // is the value ok? (not empty)
    if (!checked) {
        ok = false;
    }

    var currentClasses = context.getAttribute("class") || "";

    if (!ok) {
        var message = document.createTextNode(context.getAttribute("data-msg-required"));
        messagelabel.innerHTML = "";
        messagelabel.appendChild(message);
        if (currentClasses.indexOf("error") == -1) {
            context.setAttribute("class", currentClasses + " error");
        }
    }
    else {
        var message = document.createTextNode(context.getAttribute("data-msg-valid"));
        messagelabel.innerHTML = "";
        messagelabel.appendChild(message);
        currentClasses = currentClasses.replace(/(|\s)error(|\s)/g, "");
        context.setAttribute("class", currentClasses);
    }

    return ok;
}


function resetValidationState() {
    required = defaultRequired; // reset required flag
}

module.exports = {
    parse: parse,
    get: get,
    resetValidationState: resetValidationState,
    validate: validate,
    init: init
};




// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/terms/terms.js